/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrGridFilter from "@grapecity/wijmo.react.grid.filter"

import React, { useEffect, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import CONSTANT from "../../constant"
import VALIDATE_CONSTANT from "../../constant/validateConstant"
import NinusiService from "../../service/master/ninusi/ninusiService"
import { 荷主マスタ } from "../../service/master/ninusi/TNinusi"
import stringUtil from "../../ts/util/stringUtil"
import { TWijmoCellTemplateContext } from "../../type/wijmoComponents"
import EmptyTextHeader from "../FlexGridWrapper/EmptyTextHeader"
import GridFooter from "../FlexGridWrapper/GridFooter"
import TextInput from "../InputWrapper/TextInput"
import LocalAlertComponent from "../LocalAlertComponent"
import { ModalOuter, TModalTypes } from "../Modal/ModalOuter"
import Spinner from "../Spinner"

/**
 * 荷主検索モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const NinusiSearchModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    ninusiCode?: string
    ninusiName?: string
    setNinusi: (value: 荷主マスタ) => unknown
  }
> = (props) => {
  //#region [state]
  // 検索項目
  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主名, set荷主名] = useState<string>()

  // Grid
  const [pageSize, setPageSize] = useState<number>(50)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページサイズ
   * @returns CollectionView
   */

  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjcCore.CollectionView(data, {
      pageSize,
    })

  const [gridData, setGridData] = useState<{
    data: wjcCore.CollectionView
  }>({
    data: createCollectionView([], pageSize),
  })
  const gridInitialized = (grid: wjcGrid.FlexGrid) => {
    grid.itemsSource = gridData.data
    setFlexGrid(grid)
  }

  const search = async (searchCondition?: {
    荷主名?: string
    荷主コード?: string
  }) => {
    setIsSpinnerShow(true)
    setAlertSource(undefined)
    try {
      const res = await new NinusiService().getList({
        荷主コード: searchCondition?.荷主コード ?? 荷主コード,
        荷主名: searchCondition?.荷主名 ?? 荷主名,
      })

      const newData = createCollectionView([...res.data], pageSize)
      flexGrid!.itemsSource = newData
      setGridData({ data: newData })
      flexGrid!.refresh()
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsSpinnerShow(false)
    }
  }
  /**
   * 選択ハンドラ
   * @param item
   */
  const submitHandler = (item: 荷主マスタ) => {
    props.setNinusi(item)
    props.setIsShow(false)
  }
  //#endregion

  //#region [effect]
  useEffect(() => {
    if (flexGrid == null) return

    if (props.isShow) {
      console.log(props)
      //表示時

      // 荷主コードが設定されている場合、その荷主コードで検索
      let hasValue = false
      if (!stringUtil.isNullOrWhiteSpace(props.ninusiCode)) {
        hasValue = true
        set荷主コード(props.ninusiCode)
      }
      if (!stringUtil.isNullOrWhiteSpace(props.ninusiName)) {
        hasValue = true
        set荷主名(props.ninusiName)
      }
      if (hasValue) {
        search({ 荷主名: props.ninusiName, 荷主コード: props.ninusiCode })
      }
    } else {
      // 非表示時中身を空にして閉じる
      set荷主コード("")
      set荷主名("")
      const newData = {
        data: createCollectionView([], pageSize),
      }
      if (flexGrid != null) {
        flexGrid.itemsSource = newData.data
        flexGrid.refresh()
      }
      setGridData(newData)
    }
  }, [props.isShow, flexGrid])

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "荷主マスタ検索"}
      setIsShow={props.setIsShow}
      size={"xl"}
      footer={props.footer}>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid>
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <div className="search-condition-table">
                <div className="search-condition-row">
                  <TextInput
                    autoFocus={true}
                    style={{ width: "6rem" }}
                    id="荷主コード"
                    name="荷主コード"
                    placeholder="荷主CD"
                    value={荷主コード}
                    maxLength={VALIDATE_CONSTANT.LENGTH.荷主コード}
                    setValue={(v) => {
                      set荷主コード(v)
                    }}></TextInput>
                  <TextInput
                    style={{ width: "30rem" }}
                    id="荷主名"
                    name="荷主名"
                    value={荷主名}
                    setValue={set荷主名}
                    maxLength={100}
                    placeholder="荷主名"
                  />
                </div>
              </div>
            </Col>
            <Col className="text-end mb-2">
              <Button
                type="submit"
                onClick={(e) => {
                  e.preventDefault()
                  search()
                }}>
                <FontAwesomeIcon icon={faSearch} />
                検索
              </Button>
            </Col>
          </Row>
        </form>
        <Row>
          <Col style={{ height: "35rem" }}>
            <wjrGrid.FlexGrid
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
              keyActionTab={wjcGrid.KeyAction.None}
              selectionMode={wjcGrid.SelectionMode.Cell}
              initialized={gridInitialized}
              style={{ height: "30rem" }}>
              <wjrGridFilter.FlexGridFilter />
              <wjrGrid.FlexGridColumn
                header="選択"
                align={"center"}
                binding="荷主品名ID">
                <EmptyTextHeader></EmptyTextHeader>
                <wjrGrid.FlexGridCellTemplate
                  cellType={wjrGrid.CellTemplateType.Cell}
                  template={(
                    context: TWijmoCellTemplateContext<荷主マスタ>
                  ) => (
                    <Button onClick={() => submitHandler(context.item)}>
                      選択
                    </Button>
                  )}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={80}
                header="荷主CD"
                binding="荷主コード"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={300}
                header="荷主名"
                binding="荷主名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                header="荷主略称1"
                binding="荷主略称1"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                header="荷主略称2"
                binding="荷主略称2"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                header="荷主名カナ"
                binding="荷主名カナ"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                header="集計荷主CD"
                binding="集計荷主コード"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                header="請求対象外"
                dataType={wjcCore.DataType.Boolean}
                binding="請求対象外フラグ"></wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
            <GridFooter
              pageSize={pageSize}
              setPageSize={setPageSize}
              gridData={gridData}
              isEnableExport={false}
              flexGrid={flexGrid}></GridFooter>
          </Col>
        </Row>
      </Container>
    </ModalOuter>
  )
}

export default NinusiSearchModal
